module.exports = __webpack_public_path__ + "img/arb.f7e9bc0a.svg";